import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudInstancesCategories = () => import('./staff/crudInstancesCategories')
const ViewStaffCrudInstancesMonitorServer = () => import('./staff/crudInstancesMonitorServer')
const ViewStaffCrudInstancesMonitorSystem = () => import('./staff/crudInstancesMonitorSystem')
const ViewStaffConfigInstances = () => import('./staff/configInstances')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'InstancesStaffDashboard',
  crudInstancesCategories: 'InstancesStaffCrudInstancesCategories',
  crudInstancesMonitorServer: 'InstancesStaffCrudInstancesMonitorServer',
  crudInstancesMonitorSystem: 'InstancesStaffCrudInstancesMonitorSystem',
  configInstances: 'InstancesStaffConfigInstances',
}

const router =
  [
    {
      path: '/st/instances',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Instancias',
          }          
        },  
        {
          path: 'categories',
          name: VIEWS.crudInstancesCategories,
          component: ViewStaffCrudInstancesCategories,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Categorías de Servidores',
          }          
        },                  
        {
          path: 'monitor-server',
          name: VIEWS.crudInstancesMonitorServer,
          component: ViewStaffCrudInstancesMonitorServer,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Servidores',
          }
        },
        {
          path: 'monitor-system',
          name: VIEWS.crudInstancesMonitorSystem,
          component: ViewStaffCrudInstancesMonitorSystem,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Instancias',
          }
        },
        {
          path: 'config',
          name: VIEWS.configInstances,
          component: ViewStaffConfigInstances,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuración de Instancias',
          }
        },
      ]
    },

    {
      path: '/cu/instances',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/instances',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
